import { CSSProperties, FC, useState } from "react";
// 组件
import { ProAlert, ProInput, ProModal } from "../antd";
// 方法
import { downloadCsv } from "../utils/dataUtils";
// 常量
import { CopyPreviewData, CopyPreviewProps } from "./interface";

const textAreaStyle: CSSProperties = {
  cursor: 'default',
  backgroundColor: '#fff',
  color: '#333',
};
/** 展示复制出来的数据 */
const CopyPreview: FC<CopyPreviewProps> = props => {
  const { copyPreviewRef, copyDataTitle, formatFileName, fileName, } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<CopyPreviewData>();
  /** 显示 */
  const handleShow = (newData: CopyPreviewData) => {
    setData(newData);
    setOpen(true);
  };
  /** 隐藏 */
  const handleHide = () => {
    setOpen(false);
  };
  /** 下载 */
  const handleDownload = () => {
    const csvData: string[] = [];
    data?.csvRows?.forEach?.(item => {
      csvData.push(item.join(','));
    });
    const newFileName = formatFileName ? formatFileName() : fileName;
    downloadCsv(csvData.join('\n'), newFileName);
    handleHide();
  };
  /** 对外方法 */
  copyPreviewRef.current = {
    show: handleShow,
    hide: handleHide,
  };
  return (
    <ProModal
      title={copyDataTitle}
      open={open}
      destroyOnClose
      maskClosable={false}
      onCancel={handleHide}
      onOk={handleDownload}
      okText='下载'
      cancelText='关闭'
    >
      <ProAlert
        type="info"
        message="可将以下内容直接复制后粘贴到Excel中"
        style={{ marginBottom: 15 }}
      />
      <ProInput.TextArea
        id="text_area_copy_node"
        rows={(data?.rows && data?.rows > 8) ? data?.rows : 8}
        value={data?.copyText}
        disabled={true}
        style={textAreaStyle}
        autoSize={{ maxRows: 28, }}
      />
    </ProModal>
  );
};

CopyPreview.defaultProps = {
  copyDataTitle: '复制预览',
};

export default CopyPreview;
